<template>
  <div>
    <div v-if="path" class="row no-gutters">
      <div class="col-3">
        <label
          v-tooltip="uniToolTipTranslation('S422', 'en-US')"
          class="label-unidato fluidSelectLabel"
          >{{ uniTranslation("TRNSL41") }}</label
        >
      </div>
      <div class="col-9">
        <el-select
          v-model="selectedFluid"
          class="fluidSelect"
          placeholder="Select a fluid"
          filterable
        >
          <el-option
            v-for="item in fluidList"
            v-if="item.fast !== 0"
            :key="item.id"
            :label="item.description"
            :value="item.id"
          >
            <span style="float: left">
              <i class="fa fa-tint"></i>
              {{ item.description }}
            </span>
          </el-option>
          <el-option-group label="More">
            <el-option
              v-for="item in fluidList"
              v-if="item.fast == 0"
              :key="item.id"
              :label="item.description"
              :value="item.id"
            ></el-option>
          </el-option-group>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Select, Option, OptionGroup } from "element-ui";
import fluidService from "../../services/backend/fluidService";
import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    "el-select": Select,
    "el-option-group": OptionGroup,
    "el-option": Option
  },
  props: {
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedFluid: "",
      fluidList: []
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"])
  },
  watch: {
    selectedFluid: function(nv /*, ov*/) {
      if (nv != null && nv != undefined) {
        this.$store.dispatch("changeProjectProperty", {
          path: this.path + ".fluid.id",
          value: nv
        });
        var hasGlide = this.fluidList.find(x => x.id == nv).hasGlide;
        this.$store.dispatch("changeProjectProperty", {
          path: this.path + ".fluid.hasGlide",
          value: hasGlide // Mi indica che ho il glide
        });
      }
    }
  },
  mounted: function() {
    var that = this;
    that.$nextTick(function() {
      fluidService.getRefrigerants().then(function(data) {
        data.forEach(element => {
          that.fluidList.push({
            filename: element.filename,
            id: element.id,
            fast: element.fast,
            description: element.filename
              .split(".")
              .slice(0, -1)
              .join("."),
            hasGlide: element.hasGlide
          });
        });
        that.selectedFluid = jsonHelper.getProperty(that.projects, that.path + ".fluid.id");
      });
    });
  },
  methods: {}
};
</script>

<style lang="scss">
.fluidSelectRow {
  margin-right: 0px;
  margin-left: 0px;
  .col-3 {
    padding-right: 0px;
    padding-left: 0px;
  }
  .col-9 {
    padding-right: 0px;
    padding-left: 0px;
  }
}
.fluidSelectLabel {
  margin-top: 5px;
  //padding-left: 5px;
}
.fluidSelect {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 5px;
  padding: 0 5px;
  .el-input {
    .el-input__inner {
      height: 30px;
    }
  }
}
.numberCircle {
  float: right;
  color: #8492a6;
  font-size: 10px;

  /*border-style: solid; 
    border-width: 1px;
    border-radius: 50%;
    border: 2px solid #666;
    width: 24;
    height: 32px;*/
  text-align: center;
  vertical-align: middle;

  /*border-radius: 50%;
    / *behavior: url(PIE.htc); /* remove if you don't care about IE8 * /

    width: 32px;
    height: 32px;
    padding-top: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
    
    background: #fff;
    border: 2px solid #666;
    color: #666;
    text-align: center;
    vertical-align: middle;
    
    / *font: 32px Arial, sans-serif;*/
}
</style>
